export default __webpack_public_path__ + "static/media/bear-blue.7814b1d7.svg";